<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div v-show="optiontap == 'normaltap'">등록 기본 정보</div>
              <div v-show="optiontap == 'optiontap'">보고서 정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm" v-show="optiontap == 'normaltap'">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">보고서 분류</label>
                      </td>
                      <td class="">
                        <label class="col-form-label">종합보고서</label>
                        <!-- <b-form-select id="basicSelect" v-model="queryParams.p_type" :plain="true" :disabled="formtype == 'update'" :options="reportSubDepths">
                        </b-form-select> -->
                      </td>
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">보고서 구분</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <label class="col-form-label" v-if="formtype == 'update'">{{queryParams.p_sub_typename}}</label>
                            <b-form-select id="basicSelect" v-if="formtype == 'insert'" v-model="queryParams.p_sub_type" :plain="true" :options="reportSubDepths">
                            </b-form-select>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">보고서명</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <b-form-input id="basicText" name="p_name" type="text" v-model="queryParams.p_name" v-validate="'required'" :class="{'is-invalid': errors.has('p_name')}"></b-form-input>
                            <span v-show="errors.has('p_name')" :class="{error: errors.has('p_name')}">보고서명은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">출시일 설정</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7"><b-form-input type="text" v-model="queryParams.custom_date" name="daterange" /></b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">노출여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group
                          id="basicCustomViewyn"
                          name="viewyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="viewY" name="viewyn" class="custom-control-input" v-model="queryParams.view_yn" value="Y" checked>
                            <label class="custom-control-label" for="viewY">노출</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="viewN" name="viewyn" class="custom-control-input" v-model="queryParams.view_yn" value="N">
                            <label class="custom-control-label" for="viewN">비노출</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">리스트 노출관리</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-checkbox
                          id="bestviewcheck"
                          v-model="queryParams.bestview_yn"
                          name="bestviewcheck"
                          value="Y"
                          unchecked-value="N">
                          인기 리포트 등록
                        </b-form-checkbox>
                      </label>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
          <div class="table-responsive-sm" v-show="optiontap == 'optiontap'">
            <table class="table b-table table-striped">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1">보고서코드</th>
                        <th class="" style="border-right:1px solid #a4b7c1">보고서명</th>
                        <th class="" style="border-right:1px solid #a4b7c1">보고서구분</th>
                        <th class="" style="border-right:1px solid #a4b7c1">출시일 설정</th>
                        <th class="" style="border-right:1px solid #a4b7c1">등록일</th>
                        <th class="" style="border-right:1px solid #a4b7c1">노출</th>
                        <th class="">조회수</th>
                    </tr>
                </thead>
                <tbody class="">
                    <!---->
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.p_code}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.p_name}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.p_sub_typename}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.custom_date}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.reg_date}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{queryParams.view_name}}</td>
                        <td class="">{{queryParams.view_cnt}}</td>
                    </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-card>
          <div slot="header" v-show="optiontap == 'normaltap'">
            <strong>상세 기본 정보</strong>
          </div>
          <div slot="header" v-show="optiontap == 'optiontap'">옵션 기본 정보</div>
          <div style="margin-bottom:20px">
            <b-nav justified tabs>
              <b-nav-item v-bind:active="optiontap == 'normaltap'" v-on:click="optiontap = 'normaltap'">상세정보</b-nav-item>
              <b-nav-item v-bind:active="optiontap == 'optiontap'" v-on:click="salesPayReportInsert()">{{queryParams.p_sub_type == 'PRDT_TYPE_1_1_1' ? '가격설정' : '옵션설정'}}</b-nav-item>
              <b-nav-item disabled></b-nav-item>
              <b-nav-item disabled></b-nav-item>
            </b-nav>
          </div>
          <div class="table-responsive-sm" v-show="optiontap == 'normaltap'">
            <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
                <tbody class="">
                  <!-- <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">차감 포인트기간</label>
                      </td>
                      <td class="">
                        <b-form-select id="basicSelect" v-model="queryParams.pointminus_period" :plain="true" :options="periodOptions">
                        </b-form-select>
                      </td>
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">차감 포인트</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="5">
                            <b-form-input id="basicText" type="text" v-model="queryParams.pointminus" @keyup="numberFormat(queryParams.pointminus)" @blur="numberFormat(queryParams.pointminus)"></b-form-input>
                          </b-col>
                          <b-col sm="7">
                            R-point
                          </b-col>
                        </b-row>
                      </td>
                  </tr> -->


                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">옵션 및 가격</label>
                      </td>
                      <td class="">
                        <b-col md="7">
                          <b-button variant="info" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-on:click="salesPayReportInsert()"><i class="fa fa-list-ul"></i>{{queryParams.p_sub_type == 'PRDT_TYPE_1_1_1' ? '가격 설정하기' : '옵션 설정하기'}}</h5></b-button>
                        </b-col>
                      </td>
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">페이지 수</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" type="text" v-model="queryParams.page_cnt"></b-form-input>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">표본 수</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" type="text" v-model="queryParams.sample_comment"></b-form-input>
                          </b-col>
                        </b-row>
                      </td>
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">ISBN</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" type="text" v-model="queryParams.ibsn"></b-form-input>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">카테고리</label>
                      </td>
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <b-button size="sm" class="mx-1"
                            variant="outline-primary"
                            v-for="(categoryItem, idx) in categoryItems"
                            :key="idx"
                            :pressed.sync="categoryItem.state"
                            >
                              {{ categoryItem.item_name }}
                            </b-button>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">미리보기(JPG,PNG)</label>
                      </td>
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col md="12" style="padding:13px">
                            <vue-dropzone ref="dropPreviewFile" id="previewFile"
                              :options="previewFileOptions"
                              @vdropzone-file-added="previewAdded"
                              @vdropzone-success="previewVsuccess"
                              @vdropzone-complete="previewAfterComplete"
                              @vdropzone-upload-progress="previewProgress"
                              :duplicateCheck="false">
                              <div class="dropzone-custom-content">
                                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                                <h4 class="dropzone-custom-title mb-0 mt-3">Drag & Drop</h4>
                              </div>
                            </vue-dropzone>
                          </b-col>
                          <b-col md="6" style="margin-top:10px">
                            <draggable class="dragArea preview"
                                        :options="{animation:300, handle:'.handle'}"
                                        :component-data="getComponentData()">
                                <li class="list-group-item" style="padding:0 0 10px 10px"
                                    v-for="item, index in queryParams.previewFileItems"
                                    :key="item.no">
                                    <span class="handle" >
                                        <i class="fa fa-bars fa-lg mt-4"></i>
                                    </span>
                                    <label>
                                        <i class="fa fa-2x mt-1 bg-danger" v-bind:class="'fa-file-'+item.file_extensions+'-o'"></i> {{item.file_originalname}} ({{item.filesizeStr}})
                                        <p class="fileurl" style="display:none">{{item.file_url}}</p>
                                    </label>
                                    <label class="col-form-label" style="float:right; margin:10px 10px 0 0"><a style="cursor:pointer; color:black" v-on:click="removeListFile"><i class="fa fa-remove"></i></a></label>
                                </li>
                            </draggable>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">목록 썸네일 이미지</label>
                      </td>
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col sm="10">
                            <div style="border:1px solid #c2cfd6; border-radius:4px"><input type="file" class="form-control-file" id="file" ref="file" accept=".jpg, .jpeg, .png" style="padding:5px" v-on:change="handleFileUpload('RPT_FILE_TYPE_3')"/></div>
                            <div style="float:left" class="imgview" :data="item.file_url" v-for="item, index in queryParams.listThumbnailFile">등록된 파일 : {{item.file_originalname}} ({{item.filesizeStr}})</div>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">TAG</label>
                      </td>
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" type="text" v-model="queryParams.tag"></b-form-input>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">개요</label>
                      </td>
                      <td class="" colspan="4">
                         <vue-ckeditor v-model="queryParams.summary" :config="arConfig" />
<!--                        <textarea id="editorSummary"></textarea>-->
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">목차</label>
                      </td>
                      <td class="" colspan="4">
                         <vue-ckeditor v-model="queryParams.toc" :config="arConfig" />
<!--                        <textarea id="editorToc"></textarea>-->
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">상세설명</label>
                      </td>
                      <td class="" colspan="4">
                         <vue-ckeditor v-model="queryParams.detaile_content" :config="arConfig" />
<!--                        <textarea id="editorDetailContent"></textarea>-->
                      </td>
                  </tr>
                </tbody>
            </table>
          </div>

          <div class="table-responsive-sm" v-show="optiontap == 'optiontap'">
            <table class="table b-table table-striped" v-if="queryParams.p_sub_type == 'PRDT_TYPE_1_1_3'">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1">제책본</th>
                        <th class="">파일본</th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">
                        <a href="javascript:void(0)" v-on:click="synthesis_option_type = 'SOT_TYPE_1'; valueCheck = false">
                          <label class="col-form-label">
                            <label class="switch switch-3d switch-primary">
                              <input type="checkbox" name="tapoption" id="optcheck" class="switch-input" :checked="booktapCheck" v-on:change="synthesisOptTapCheck($event,booktapCheck)"> <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </label>
                        </a>
                      </td>
                      <td class="">
                        <a href="javascript:void(0)" v-on:click="synthesis_option_type = 'SOT_TYPE_2'; valueCheck = false">
                          <label class="col-form-label">
                            <label class="switch switch-3d switch-primary">
                              <input type="checkbox" name="tapoption" id="pkgcheck" class="switch-input" :checked="opttapCheck" v-on:change="synthesisOptTapCheck($event,opttapCheck)"> <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label> {{optList.length}}종
                          </label>
                        </a>
                      </td>
                    </tr>
                </tbody>
            </table>
            <!-- <table class="table b-table table-striped" v-if="queryParams.p_sub_type == 'PRDT_TYPE_1_1_2'">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="">주옵션</th>
                    </tr>
                </thead>
                <tbody class="">
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                      <td class="" style="border-right:1px solid #a4b7c1">
                        <a href="javascript:void(0)" v-on:click="tap_option_type = 'POT_1'; valueCheck = false">
                          <label class="col-form-label">
                            <label class="switch switch-3d switch-primary">
                              <input type="checkbox" name="tapoption" id="optcheck" class="switch-input" :checked="opttapCheck" v-on:change="optPkgCheck($event,opttapCheck)"> <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label> {{optList.length}}종
                          </label>
                        </a>
                      </td>
                      <td class="">
                        <a href="javascript:void(0)" v-on:click="tap_option_type = 'POT_2'; valueCheck = false">
                          <label class="col-form-label">
                            <label class="switch switch-3d switch-primary">
                              <input type="checkbox" name="tapoption" id="pkgcheck" class="switch-input" :checked="pkgtapCheck" v-on:change="optPkgCheck($event,pkgtapCheck)"> <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label> {{pkgList.length}}종
                          </label>
                        </a>
                      </td>
                    </tr>
                </tbody>
            </table> -->
            <div class="table-responsive-sm">
              <table class="table b-table table-striped" v-if="synthesis_option_type == 'SOT_TYPE_1' && (queryParams.p_sub_type == 'PRDT_TYPE_1_1_1' || queryParams.p_sub_type == 'PRDT_TYPE_1_1_3')">
                  <thead class="" style="background-color:#f1f1f1">
                      <tr style="text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1">옵션분류</th>
                          <th class="" style="border-right:1px solid #a4b7c1">{{queryParams.p_type == 'PRDT_TYPE_1_1' ? '종합보고서 옵션명' : '패키지명'}}</th>
                          <th class="" style="border-right:1px solid #a4b7c1">노출여부(우선순위)</th>
                          <th class="" style="border-right:1px solid #a4b7c1">소비자가</th>
                          <th class="">관리</th>
                      </tr>
                  </thead>
                  <tbody class="">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{queryParams.p_type == 'PRDT_TYPE_1_1' ? '종합보고서' : '패키지옵션'}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">
                            <b-row class="pt-sm-12">
                              <b-col sm="12">
                                <b-form-input id="basicText" type="text" :class="(pkgDatas.name == undefined || pkgDatas.name == '') && valueCheck ? 'is-invalid' : ''" v-model="pkgDatas.name"></b-form-input>
                                <span class="error" v-show="(pkgDatas.name == undefined || pkgDatas.name == '') && valueCheck">패키지명을 입력해주세요.</span>
                              </b-col>
                            </b-row>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">
                            <b-form-select id="basicSelect" v-model="pkgDatas.exposure"
                              :plain="true"
                              :options="pkgExposureOptions"
                              :value="null">
                            </b-form-select>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">
                            <!-- 종합보고서 -->
                            <b-row class="pt-sm-12" v-if="queryParams.p_type == 'PRDT_TYPE_1_1'">
                              <b-col sm="11" style="margin-top:10px">
                                <b-form-input id="basicText" type="text" v-model="pkgDatas.normal_price" @keyup="numberFormatPkg(pkgDatas.normal_price, 'normal_price')" @blur="numberFormatPkg(pkgDatas.price, 'normal_price')"></b-form-input>
                              </b-col>
                              <label style="margin-top:12px; padding-top:7px">원</label>
                            </b-row>
                            <!-- 이벤트패키지 -->
                            <b-row class="pt-sm-12" v-if="queryParams.p_type == 'PRDT_TYPE_1_2'">
                              <b-col sm="2" style="padding:0; font-size:20px">
                                보안PDF :
                              </b-col>
                              <b-col sm="9" style="padding-left:0px">
                                <b-form-input id="basicText" type="text" v-model="pkgDatas.security_price" @keyup="numberFormatPkg(pkgDatas.security_price, 'security_price')" @blur="numberFormatPkg(pkgDatas.security_price, 'security_price')"></b-form-input>
                              </b-col>
                              <label style="padding-top:7px">원</label>
                              <b-col sm="2" style="padding:0; font-size:20px; margin-top:12px">
                                일반PDF :
                              </b-col>
                              <b-col sm="9" style="padding-left:0px; margin-top:12px">
                                <b-form-input id="basicText" type="text" v-model="pkgDatas.normal_price" @keyup="numberFormatPkg(pkgDatas.normal_price, 'normal_price')" @blur="numberFormatPkg(pkgDatas.price, 'normal_price')"></b-form-input>
                              </b-col>
                              <label style="margin-top:12px; padding-top:7px">원</label>
                            </b-row>

                          </td>
                          <td class="" style="vertical-align:middle">
                            <b-row class="pt-sm-12">
                              <b-col sm="12" style="margin-top:-15px">
                                <b-button variant="info" style="color:#ffffff" v-on:click="addDrOpt(pkgDatas)"><i class="fa fa-hand-o-up"></i> 추가</b-button>
                                <a href="javascript:void(0)" v-on:click="newPkgClear()"><i class="fa fa-undo fa-lg mt-4"></i></a>
                              </b-col>
                            </b-row>

                          </td>
                      </tr>
                  </tbody>
              </table>

              <!-- -->
              <table class="table b-table table-striped" v-if="synthesis_option_type == 'SOT_TYPE_1' && (queryParams.p_sub_type == 'PRDT_TYPE_1_1_1' || queryParams.p_sub_type == 'PRDT_TYPE_1_1_3')">
                  <thead class="" style="background-color:#f1f1f1">
                      <tr style="text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1">번호</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션분류</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션코드</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션명</th>
                          <th class="" style="border-right:1px solid #a4b7c1">소비자가</th>
                          <th class="" style="border-right:1px solid #a4b7c1">노출여부</th>
                          <th class="" style="border-right:1px solid #a4b7c1" v-if="queryParams.p_type == 'PRDT_TYPE_1_2'">옵션수량</th>
                          <th class="" style="border-right:1px solid #a4b7c1">등록일</th>
                          <th class="" style="border-right:1px solid #a4b7c1">등록자</th>
                          <th class="">관리</th>
                      </tr>
                  </thead>
                  <tbody class="">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="pkgList.length > 0" v-for="(item, idx) in pkgList">
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{idx+1}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{queryParams.p_type == 'PRDT_TYPE_1_1' ? '종합보고서' : '패키지'}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.pkg_code}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.name}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; text-align:center" v-if="queryParams.p_type == 'PRDT_TYPE_1_1'">
                            <span>₩ {{item.normal_price}}</span>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1; text-align:left" v-if="queryParams.p_type == 'PRDT_TYPE_1_2'">
                            <span style="padding-left:20px">보안PDF : ₩ {{item.security_price}}</span></br>
                            <span style="padding-left:20px">일반PDF : ₩ {{item.normal_price}}</span></br>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle"><span v-text="item.exposure == 0 ? '비노출' : '노출'"></span>({{item.exposure}})</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle" v-if="queryParams.p_type == 'PRDT_TYPE_1_2'">{{item.opt_cnt}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.reg_date}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.reg_name}}</td>
                          <td class="" style="vertical-align:middle">
                            <a href="javascript:void(0)" v-on:click="editPkg(item)">수정</a>
                          </td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="pkgList.length == 0">
                          <td class="" colspan="10">데이터가 없습니다.</td>
                      </tr>
                  </tbody>
              </table>
            </div>

            <div v-if="synthesis_option_type == 'SOT_TYPE_2' && (queryParams.p_sub_type == 'PRDT_TYPE_1_1_2' || queryParams.p_sub_type == 'PRDT_TYPE_1_1_3')">
              <table class="table b-table table-striped">
                  <thead class="" style="background-color:#f1f1f1">
                      <tr style="text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1; width:120px">옵션분류</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션명</th>
                          <th class="" style="border-right:1px solid #a4b7c1">노출여부(우선순위)</th>
                          <!-- <th class="" style="border-right:1px solid #a4b7c1">소비자가</th> -->
                          <th class="">관리</th>
                      </tr>
                  </thead>
                  <tbody class="">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                          <td class="" style="border-right:1px solid #a4b7c1">주옵션</td>
                          <td class="" style="border-right:1px solid #a4b7c1">
                            <b-row class="pt-sm-12">
                              <b-col sm="12">
                                <b-form-input id="basicText" type="text" :class="(optDatas.name == undefined || optDatas.name == '') && valueCheck ? 'is-invalid' : ''" v-model="optDatas.name"></b-form-input>
                                <span class="error" v-show="(optDatas.name == undefined || optDatas.name == '') && valueCheck">옵션명을 입력해주세요.</span>
                              </b-col>
                            </b-row>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1">
                            <b-form-select id="basicSelect" v-model="optDatas.exposure"
                              :plain="true"
                              :options="optExposureOptions"
                              :value="null">
                            </b-form-select>
                          </td>
                          <!-- <td class="" style="border-right:1px solid #a4b7c1">
                            <b-row class="pt-sm-12">
                              <b-col sm="11">
                                <b-form-input id="basicText" type="text" name="optprice" v-model="optDatas.price" @keyup="numberFormatOpt(optDatas.price)" @blur="numberFormatOpt(optDatas.price)"></b-form-input>
                              </b-col>
                              <label>원</label>
                            </b-row>
                          </td> -->
                          <td class="" style="vertical-align:middle">
                            <b-row class="pt-sm-12">
                              <b-col sm="12">
                                <b-button variant="info" style="color:#ffffff" v-on:click="addDrSynthesisOpt(optDatas)"><i class="fa fa-hand-o-up"></i> 추가</b-button>
                                <a href="javascript:void(0)" v-on:click="newOptClear()"><i class="fa fa-undo fa-lg mt-4"></i></a>
                              </b-col>
                            </b-row>
                          </td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                          <td class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; font-weight:bold">
                            <label class="col-form-label">보고서 파일</label>
                          </td>
                          <td class="" colspan="4">
                            <b-row class="pt-sm-12">
                              <b-col sm="12">
                                <table style="width:100%">
                                  <tr>
                                    <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:0px; width:87px">
                                      보안 파일 :
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; padding:0px; width:1000px">
                                      <div style="border:1px solid #c2cfd6; border-radius:4px; width:100%"><input type="file" class="form-control-file" id="securityfile" ref="securityfile" :disabled="securityFileYn" style="padding:5px" v-on:change="securityFileUpload"/></div>
                                      <b-progress :value="progressCounter" :max="100" show-progress animated style="margin-top:5px; display:none" id="securityProgress"></b-progress>
                                      <div style="float:left" v-for="item, index in securityFileItem" v-show="!securityFileYn">등록된 파일 : {{item.file_originalname}} ({{item.filesizeStr}})</div>
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; padding:0 0 0 15px; width:300px">
                                      <b-form-input id="basicText" type="text" name="securityprice" style="width:80%; float:left; padding:18px" v-model="optDatas.security_price" @keyup="numberFormatSecurity(optDatas.security_price)" @blur="numberFormatSecurity(optDatas.security_price)"></b-form-input>
                                      <div style="float:right; width:20%; float:right"><label class="col-form-label">원</label></div>
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:0px; width:132px">
                                      <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="securityfileyn" v-model="securityFileYn" v-on:click="securityFileYnCheck">
                                        <label class="custom-control-label" for="securityfileyn">파일 없음</label>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:5px 0 0 0px; width:87px">
                                      일반 파일 :
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; padding:5px 0 0 0px; width:1000px">
                                      <div style="border:1px solid #c2cfd6; border-radius:4px; width:100%"><input type="file" class="form-control-file" id="normalfile" ref="normalfile" :disabled="normalFileYn" style="padding:5px" v-on:change="normalFileUpload"/></div>
                                      <b-progress :value="progressCounter" :max="100" show-progress animated style="margin-top:5px; display:none" id="normalProgress"></b-progress>
                                      <div style="float:left" v-for="item, index in normalFileItem" v-show="!normalFileYn">등록된 파일 : {{item.file_originalname}} ({{item.filesizeStr}})</div>
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; padding:5px 0px 0px 15px; width:300px">
                                      <b-form-input id="basicText" type="text" name="normalprice" style="width:80%; float:left; padding:18px" v-model="optDatas.normal_price" @keyup="numberFormatNormal(optDatas.normal_price)" @blur="numberFormatNormal(optDatas.normal_price)"></b-form-input>
                                      <div style="float:right; width:20%; float:right"><label class="col-form-label">원</label></div>
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:5px 0 0 0px; width:132px">
                                      <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="normalfileyn" v-model="normalFileYn" v-on:click="normalFileYnCheck">
                                        <label class="custom-control-label" for="normalfileyn">파일 없음</label>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:5px 0 0 0px; width:87px">
                                      원본 파일 :
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; padding:5px 0 0 0px; width:1000px">
                                      <div style="border:1px solid #c2cfd6; border-radius:4px; width:100%"><input type="file" class="form-control-file" id="originalfile" ref="originalfile" :disabled="originalFileYn" style="padding:5px" v-on:change="originalFileUpload"/></div>
                                      <b-progress :value="progressCounter" :max="100" show-progress animated style="margin-top:5px; display:none" id="originalProgress"></b-progress>
                                      <div style="float:left" v-for="item, index in originalFileItem" v-show="!originalFileYn">등록된 파일 : {{item.file_originalname}} ({{item.filesizeStr}})</div>
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; padding:5px 0px 0px 15px; width:300px">
                                      <b-form-input id="basicText" type="text" name="originalprice" style="width:80%; float:left; padding:18px" v-model="optDatas.original_price" @keyup="numberFormatOriginal(optDatas.original_price)" @blur="numberFormatOriginal(optDatas.original_price)"></b-form-input>
                                      <div style="float:right; width:20%; float:right"><label class="col-form-label">원</label></div>
                                    </td>
                                    <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:5px 0 0 0px; width:132px">
                                      <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" id="originalfileyn" v-model="originalFileYn" v-on:click="originalFileYnCheck">
                                        <label class="custom-control-label" for="originalfileyn">파일 없음</label>
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </b-col>
                            </b-row>
                          </td>
                      </tr>
                  </tbody>
              </table>

              <!-- -->
              <table class="table b-table table-striped">
                  <thead class="" style="background-color:#f1f1f1">
                      <tr style="text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1">번호</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션분류</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션코드</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션명</th>
                          <th class="" style="border-right:1px solid #a4b7c1">소비자가</th>
                          <th class="" style="border-right:1px solid #a4b7c1">노출여부</th>
                          <th class="" style="border-right:1px solid #a4b7c1">등록일</th>
                          <th class="" style="border-right:1px solid #a4b7c1">등록자</th>
                          <th class="">관리</th>
                      </tr>
                  </thead>
                  <tbody class="">
                      <!---->
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="optList.length > 0" v-for="(item, idx) in optList">
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{idx+1}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">주옵션</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.opt_code}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.name}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                            <span style="padding-left:20px">보안 파일 : ￦ {{item.security_price}}</span></br>
                            <span style="padding-left:20px">일반 파일 : ￦ {{item.normal_price}}</span></br>
                            <span style="padding-left:20px">원본 파일 : ￦ {{item.original_price}}</span>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle"><span v-text="item.exposure == 0 ? '비노출' : '노출'"></span>({{item.exposure}})</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.reg_date}}</td>
                          <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">{{item.reg_name}}</th>
                          <td class="" style="vertical-align:middle">
                            <!-- <a href="javascript:void(0)" v-on:click="editOpt(item)">수정</a> / <a href="javascript:void(0)" v-on:click="deleteOpt(item)">삭제</a> -->
                            <a href="javascript:void(0)" v-on:click="editSynthesisOpt(item)">수정</a> / <a href="javascript:void(0)" v-on:click="deleteSynthesisOpt(item)">삭제</a>
                          </td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="optList.length == 0">
                          <td class="" colspan="9">데이터가 없습니다.</td>
                      </tr>
                  </tbody>
              </table>
            </div>

            <!-- <div class="table-responsive-sm" v-show="tap_option_type == 'POT_2' && queryParams.p_sub_type == 'PRDT_TYPE_1_1_2'">
              <table class="table b-table table-striped">
                  <thead class="" style="background-color:#f1f1f1">
                      <tr style="text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1">옵션분류</th>
                          <th class="" style="border-right:1px solid #a4b7c1">패키지명</th>
                          <th class="" style="border-right:1px solid #a4b7c1">노출여부(우선순위)</th>
                          <th class="" style="border-right:1px solid #a4b7c1">소비자가</th>
                          <th class="">관리</th>
                      </tr>
                  </thead>
                  <tbody class="">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">패키지</td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">
                            <b-row class="pt-sm-12">
                              <b-col sm="12">
                                <b-form-input id="basicText" type="text" :class="(pkgDatas.name == undefined || pkgDatas.name == '') && valueCheck ? 'is-invalid' : ''" v-model="pkgDatas.name"></b-form-input>
                                <span class="error" v-show="(pkgDatas.name == undefined || pkgDatas.name == '') && valueCheck">패키지명을 입력해주세요.</span>
                              </b-col>
                            </b-row>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">
                            <b-form-select id="basicSelect" v-model="pkgDatas.exposure"
                              :plain="true"
                              :options="pkgExposureOptions"
                              :value="null">
                            </b-form-select>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1">
                            <b-row class="pt-sm-12">
                              <b-col sm="2" style="padding:0; font-size:20px">
                                보안PDF :
                              </b-col>
                              <b-col sm="9" style="padding-left:0px">
                                <b-form-input id="basicText" type="text" v-model="pkgDatas.security_price" @keyup="numberFormatPkg(pkgDatas.security_price, 'security_price')" @blur="numberFormatPkg(pkgDatas.security_price, 'security_price')"></b-form-input>
                              </b-col>
                              <label style="padding-top:7px">원</label>
                              <b-col sm="2" style="padding:0; font-size:20px; margin-top:12px">
                                일반PDF :
                              </b-col>
                              <b-col sm="9" style="padding-left:0px; margin-top:12px">
                                <b-form-input id="basicText" type="text" v-model="pkgDatas.normal_price" @keyup="numberFormatPkg(pkgDatas.normal_price, 'normal_price')" @blur="numberFormatPkg(pkgDatas.price, 'normal_price')"></b-form-input>
                              </b-col>
                              <label style="margin-top:12px; padding-top:7px">원</label>
                            </b-row>
                          </td>
                          <td class="" style="vertical-align:middle">
                            <b-row class="pt-sm-12">
                              <b-col sm="12" style="margin-top:-15px">
                                <b-button variant="info" style="color:#ffffff" v-on:click="addDrSynthesisOpt(pkgDatas)"><i class="fa fa-hand-o-up"></i> 추가</b-button>
                                <a href="javascript:void(0)" v-on:click="newPkgClear()"><i class="fa fa-undo fa-lg mt-4"></i></a>
                              </b-col>
                            </b-row>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <table class="table b-table table-striped">
                  <thead class="" style="background-color:#f1f1f1">
                      <tr style="text-align:center">
                          <th class="" style="border-right:1px solid #a4b7c1">번호</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션분류</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션코드</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션명</th>
                          <th class="" style="border-right:1px solid #a4b7c1">소비자가</th>
                          <th class="" style="border-right:1px solid #a4b7c1">노출여부</th>
                          <th class="" style="border-right:1px solid #a4b7c1">옵션수량</th>
                          <th class="" style="border-right:1px solid #a4b7c1">등록일</th>
                          <th class="" style="border-right:1px solid #a4b7c1">등록자</th>
                          <th class="">관리</th>
                      </tr>
                  </thead>
                  <tbody class="">
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="pkgList.length > 0" v-for="(item, idx) in pkgList">
                          <td class="" style="border-right:1px solid #a4b7c1">{{idx+1}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1">패키지</td>
                          <td class="" style="border-right:1px solid #a4b7c1">{{item.opt_code}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1">{{item.name}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1; text-align:left">
                            <span style="padding-left:20px">보안 PDF : ￦ {{item.security_price}}</span></br>
                            <span style="padding-left:20px">일반 PDF : ￦ {{item.normal_price}}</span></br>
                          </td>
                          <td class="" style="border-right:1px solid #a4b7c1"><span v-text="item.exposure == 0 ? '비노출' : '노출'"></span>({{item.exposure}})</td>
                          <td class="" style="border-right:1px solid #a4b7c1">{{item.opt_cnt}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1">{{item.reg_date}}</td>
                          <td class="" style="border-right:1px solid #a4b7c1">{{item.reg_name}}</td>
                          <td class="">
                            <a href="javascript:void(0)" v-on:click="openOptPkg(item)">옵션선택</a> / <a href="javascript:void(0)" v-on:click="editPkg(item)">수정</a>
                          </td>
                      </tr>
                      <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center" v-show="pkgList.length == 0">
                          <td class="" colspan="10">데이터가 없습니다.</td>
                      </tr>
                  </tbody>
              </table>
            </div> -->
          </div>
        </b-card>
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                  <span v-show="errors.has('p_name')" :class="{error: errors.has('p_name')}">보고서명은 필수 항목 입니다.</span>
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="formtype == 'insert' ? insertDrProduct() : updateDrProduct()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/product/synthesisreport'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal title="패키지 옵션 관리" size="xl" v-model="formModal" @ok="formModal = false"
    no-close-on-backdrop no-close-on-esc hide-footer>
      <synthesisOptModal v-bind:reportOptions="reportOptions" v-bind:formModal="formModal" ref="reportOptModalRef"></synthesisOptModal>
      <hr />
      <span class="float-right" style="padding-right:20px;">
        <!-- <b-button variant="outline-primary" @click="managerSave()">저장</b-button>
        <b-button variant="outline-success" @click="formModal = false">취소</b-button> -->
        <b-button variant="outline-primary" @click="addDrPkgOpt()">저장</b-button>
        <b-button variant="outline-success" @click="formModal = false">취소</b-button>
      </span>
    </b-modal>
  </div>
</template>
<script>
import Vue from 'vue';

import datetimepicker from "daterangepicker/daterangepicker.js";
import synthesisOptModal from './SynthesisOptModal';
// import VueCkeditor from 'vue-ckeditor2';
import draggable from "vuedraggable";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import { codeAPI } from '../../common/code.js'

import VueCkeditor from 'vue-ckeditor2';

// import Summernote from 'summernote/dist/summernote-bs4.js'
// import SummernoteLang from 'summernote/dist/lang/summernote-ko-KR.js'
// import 'bootstrap'

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    VueCkeditor,
    // Summernote,
    synthesisOptModal,
    draggable,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      progressCounter: 0,
      progressTimer: null,
      isNew: true,
      booktapCheck:true,
      opttapCheck:false,
      pkgtapCheck:false,
      formModal:false,
      valueCheck:false,
      p_param_code: '',
      p_unique_code: '',
      formtype: '',
      pkgtype: '',
      codeItemDatas: [],
      reportOptions: {
        optItems: [],
        pkgItems: [],
      },
      newFlag:'new',
      pageOptions: [5, 10, 30, 50, 100],
      reportPkgOptDatas: {
        pkgOptList: []
      },
      queryParams: {
        p_type: 'PRDT_TYPE_1_1',
        p_sub_type: '',
        view_yn: 'Y',
        sales_type: 'free',
        bestview_yn: "N",
        pointminus_period: '1',
        pointminus: 0,
        previewFileItems:[],
        listThumbnailFile:[],
        categoryitems:[],
        custom_date: moment().format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
      },
      arConfig: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
          '-',
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
        ],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
      optFileYn: false,
      // optDatas: {price: 0},
      // pkgDatas: {security_price: 0, normal_price: 0},
      // optList: [],
      // pkgList: [],
      // pkgOptList: [],
      optionFileItem: [],
      securityFileYn: false,
      normalFileYn: false,
      originalFileYn: false,
      optDatas: {
        security_originalfile_name: '',
        security_filesizeStr: '',
        normal_originalfile_name: '',
        normal_filesizeStr: '',
        original_originalfile_name: '',
        original_filesizeStr: '',
        security_price: 0,
        normal_price: 0,
        original_price: 0,
      },
      pkgDatas: {normal_price: 0, security_price: 0},
      optList: [],
      pkgList: [],
      // pkgOptList: [],
      securityFileItem: [],
      normalFileItem: [],
      originalFileItem: [],
      optiontap:'normaltap',
      tap_option_type:'POT_1',
      synthesis_option_type: 'SOT_TYPE_1',
      reportSubDepths: [],
      categoryItems: [],
      periodOptions: [],
      optExposureOptions: [
        {text: '비노출',value: 0}
      ],
      pkgExposureOptions: [
        {text: '비노출',value: 0}
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().add(-365, 'days').format('YYYY-MM-DD'),
      enabled: true,
      previewFileOptions: {
          url: 'backend/ftpserver/dropAndSingleFileUpload',
          autoProcessQueue: false,
          params: {
            files: "file",
            reportType: "ar",
            fileSubPath: "img",
          },
          thumbnailWidth: 150,
          //maxFilesize: 5.0,
          acceptedFiles: '.jpg,.jpeg,.png',
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Drop files here to upload",
      },
      dragging: false,
      isDragging : false,
      file: ''
    }
  },
  watch: {
    'queryParams.previewFileItems' () {
      console.log("================== watch previewFileItems ======================");
      console.log(this.queryParams.previewFileItems.length);
      console.log("================== watch previewFileItems ======================");
    },
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    var resultDatas = [];

    // 상단 셀렉트 박스 코드 조회
    codeAPI.selectItemCodeList(self,"PRDT_TYPE_1_1",4,"codeItemDatas");
    // codeAPI.selectItemCodeList(self,"RPT_CATE",2,"categoryItems");

    setTimeout(function(){
      // self.categoryItems.forEach(function (el, idx, arr){
      //   if(idx == 0){
      //     el.state = true;
      //   }else{
      //     el.state = false;
      //   }
      // });

      self.codeItemDatas.forEach(function (el, idx, arr){
        var items = {
          text: el.item_name,
          value: el.item_code,
        };
        resultDatas.push(items);
      });
      self.reportSubDepths = resultDatas;
      self.reportSubDepths.forEach(function (el, idx, arr){
        if(idx == 0){
          if(self.formtype != 'update'){
            self.queryParams.p_sub_type = el.value;
          }
        }
      });
    }, 500);

    // ### 코드 정보 불러오기 ###
    // 신규코드를 DB테이블에 저장
    //
    // 최초작성 : 2016.05.31
    // 파라미터 : parentCode
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    self.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=RPT_CATE')
    .then((result) => {
      var categoryDatas = result.data;
      categoryDatas.forEach(function (el, idx, arr){
        if(self.formtype == 'insert'){
          if(idx == 0){
            el.state = true;
          }else{
            el.state = false;
          }
        }else{
          el.state = false;
        }
      });
      self.categoryItems = categoryDatas;
    })
    // this.selectItemCodeList(self.dr_topdeth_code,3);

    self.p_param_code = self.$session.get('p_param_code');
    self.dr_topdeth_code = self.$session.get('dr_topdeth_code');
    self.p_unique_code = "AR";
    self.formtype = self.$route.query.status;
    self.pkgtype = self.$route.query.pkgtype;
    if(self.formtype == 'update'){
      self.$http.get('/api/select/drProductData?access_token=' + token + '&p_param_code=' + self.p_param_code)
      .then((result) => {
        self.queryParams = result.data;
        console.log("================================= queryParams =================================");
        console.log(result.data);
        console.log("================================= queryParams =================================");
        self.optiontap = 'normaltap';

        // if(result.data.summary){
        //   $('#editorSummary').summernote('pasteHTML', result.data.summary);
        // }
        // if(result.data.toc){
        //   $('#editorToc').summernote('pasteHTML', result.data.toc);
        // }
        // if(result.data.detaile_content){
        //   $('#editorDetailContent').summernote('pasteHTML', result.data.detaile_content);
        // }

        setTimeout(function(){
          self.categoryItems.forEach(function (t_el, t_idx, t_arr){
            self.queryParams.categoryitems.forEach(function (s_el, s_idx, s_arr){
              if(t_el.item_code == s_el.cate_code){
                t_el.state = true;
              }
            });
          });
        }, 100);
        if(self.pkgtype){
          self.optiontap = 'optiontap';
        }
        self.getDrOptList(self.p_param_code);
      })
    }

    $(function() {
      $('input[name="daterange"]').daterangepicker({
        opens: 'left',
        singleDatePicker: true,
        "locale": self.calendarLocale,
        "endDate": moment().format('YYYY-MM-DD'),
        "startDate": moment().format('YYYY-MM-DD')
      }, function(start, end, label) {
        self.startDate = start.format('YYYY-MM-DD');
        self.queryParams.custom_date = self.startDate;
        self.endDate = end.format('YYYY-MM-DD');
      });
    });

    //개요
    // $('#editorSummary').summernote({
    //   height: 300, //에디터 높이
    //   focus: false, //에디터 로딩 후 포커스를 맞출지 여부
    //   lang: "ko-KR", // 한글 설정
    //   // placeholder: '최대 2048자까지 쓸 수 있습니다', //placeholder 설정
    //   callbacks: {
		// 			onImageUpload : function(files) {
    //         self.uploadSummernoteImageFile(files[0],this);
		// 			},
		// 			onChange: function(contents, $editable) {
    //         self.queryParams.summary = contents;
    //       }
		// 	  }
    // });
    //
    // setTimeout(function() {
    //   var code = $('#editorSummary').summernote('code');
    //   if (code.startsWith('<p><br></p>')) {
    //     code = code.substring('<p><br></p>'.length);
    //     $('#editorSummary').summernote('code', code);
    //   }
    // }, 400);
    //
    //
    // //목차
    // $('#editorToc').summernote({
    //   height: 300, //에디터 높이
    //   focus: false, //에디터 로딩 후 포커스를 맞출지 여부
    //   lang: "ko-KR", // 한글 설정
    //   // placeholder: '최대 2048자까지 쓸 수 있습니다', //placeholder 설정
    //   callbacks: {
		// 			onImageUpload : function(files) {
    //         self.uploadSummernoteImageFile(files[0],this);
		// 			},
		// 			onChange: function(contents, $editable) {
    //         self.queryParams.toc = contents;
    //       }
		// 	  }
    // });
    //
    // setTimeout(function() {
    //   var code = $('#editorToc').summernote('code');
    //   if (code.startsWith('<p><br></p>')) {
    //     code = code.substring('<p><br></p>'.length);
    //     $('#editorToc').summernote('code', code);
    //   }
    // }, 400);
    //
    // //상세설명
    // $('#editorDetailContent').summernote({
    //   height: 300, //에디터 높이
    //   focus: false, //에디터 로딩 후 포커스를 맞출지 여부
    //   lang: "ko-KR", // 한글 설정
    //   // placeholder: '최대 2048자까지 쓸 수 있습니다', //placeholder 설정
    //   callbacks: {
		// 			onImageUpload : function(files) {
    //         self.uploadSummernoteImageFile(files[0],this);
		// 			},
		// 			onChange: function(contents, $editable) {
    //         self.queryParams.detaile_content = contents;
    //       }
		// 	  }
    // });
    //
    // setTimeout(function() {
    //   var code = $('#editorDetailContent').summernote('code');
    //   if (code.startsWith('<p><br></p>')) {
    //     code = code.substring('<p><br></p>'.length);
    //     $('#editorDetailContent').summernote('code', code);
    //   }
    // }, 400);
  },
  methods: {
    // 메소드명 : getDrProductData(val)
    // ### 리포트 데이터 갱신 ###
    // 메소드 저장후 데이터 갱신용으로 사용
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.10  황경현   최초작성
    // *************************
    getDrProductData(p_param_code) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/drProductData?access_token=' + token + '&p_param_code=' + p_param_code)
      .then((result) => {
        self.queryParams = result.data;
        setTimeout(function(){
          self.categoryItems.forEach(function (t_el, t_idx, t_arr){
            self.queryParams.categoryitems.forEach(function (s_el, s_idx, s_arr){
              if(t_el.item_code == s_el.cate_code){
                t_el.state = true;
              }
            });
          });
        }, 100);
        self.getDrOptList(p_param_code);
      })
    },
    // 메소드명 : numberFormat(val)
    // ### 숫자입력함수 ###
    // 신규코드를 DB테이블에 저장
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    numberFormat(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 7){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 7){ val = val.substring(0, val.length-1); }
				this.queryParams.pointminus = "0";
      }else{
        this.queryParams.pointminus = Number(val).toLocaleString();
      }
    },
    numberFormatSecurity(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.optDatas.security_price = "0";
      }else{
        this.optDatas.security_price = Number(val).toLocaleString();
      }
    },
    numberFormatNormal(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.optDatas.normal_price = "0";
      }else{
        this.optDatas.normal_price = Number(val).toLocaleString();
      }
    },
    numberFormatOriginal(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.optDatas.original_price = "0";
      }else{
        this.optDatas.original_price = Number(val).toLocaleString();
      }
    },
    numberFormatOpt(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.optDatas.price = "0";
      }else{
        this.optDatas.price = Number(val).toLocaleString();
      }
    },
    numberFormatPkg(val, targetId) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.pkgDatas[targetId] = "0";
      }else{
        this.pkgDatas[targetId] = Number(val).toLocaleString();
      }
    },
    // 메소드명 : onFileChange(parentCode, depth)
    // ### 단일 파일다운로드 ###
    // 단일로 파일을 넘겨 받는다.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - e(해당 함수 이벤트가 일어 날시에 가져온다)
    //  - depth(대분류,소분류 구분)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.queryParams.files = files;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/common/optFtpFileUpload?access_token=' + token, data, null)
        .then((result) => {
          this.items = result.data;
        })
    },
    //첨부파일 업로드 후 실행
    dropzoneAfterComplete(file) {
      // console.log(file);
    },
    // 메소드명 : removeListFile(e)
    // ### 드랍앤드래그 리스트 삭제 ###
    // 드랍앤드래그 삭제시 리스트 순서 정렬과 해당데이터 갱신
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - e(이벤트 발생시)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    removeListFile(e) {
      var fileLists = [];
      var className = e.target.parentNode.parentNode.parentNode.parentNode.classList[1];
      var targetFileUrl = e.target.parentNode.parentNode.parentNode.children[1].lastChild.innerText;
      if(className == "attachment"){
        fileLists = this.queryParams.attachmentFileItems;
      }else if(className == "preview"){
        fileLists = this.queryParams.previewFileItems;
      }

      fileLists.forEach(function (el, idx, arr){
        if(el.file_url == $.trim(targetFileUrl)){
          fileLists.splice(idx, 1);
        }
      });
      fileLists.forEach(function (el, idx, arr){
        el.file_sequence = (idx+1);
      });

      if(className == "attachment"){
        this.queryParams.attachmentFileItems = fileLists;
      }else if(className == "preview"){
        this.queryParams.previewFileItems = fileLists;
      }
    },


    //미리보기 업로드 후 실행
    previewAfterComplete(file) {
      // console.log(file);
    },
    // 메소드명 : previewAdded()
    // ### 파일 10개 제한 ###
    // 파일이 10개 까지 제한으로 하는 메소드.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    previewAdded (event){
      var self = this;
      setTimeout(function(){
        if(self.queryParams.previewFileItems.length >= 10){
          swal.fire({
            title: '파일 최대 업로드!',
            html: "파일은 최대 10개까지 업로드 가능 합니다.",
            type: 'warning',
          })
          self.$refs.dropPreviewFile.removeAllFiles();
        }else{
          self.$refs.dropPreviewFile.processQueue();
        }

      }, 100);
    },
    // 메소드명 : previewVsuccess(file, response)
    // ### 드랍존 파일업로드 ###
    // dropzoneVsuccess과 같은 기능
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - file(현재 파일)
    //  - response(다운로드후 발생하는 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    previewVsuccess(file, response) {
      if(this.queryParams.previewFileItems.length == 0){
        response.file_sequence = 1;
        response.file_type_code = 'RPT_FILE_TYPE_2';
      }else{
        response.file_sequence = this.queryParams.previewFileItems.length+1;
        response.file_type_code = 'RPT_FILE_TYPE_2';
      }

      if(this.queryParams.previewFileItems.length >= 10){
        swal.fire({
          title: '파일 최대 업로드!',
          html: "파일은 최대 10개까지 업로드 가능 합니다.",
          type: 'warning',
        })
        this.$refs.previewFileItems.removeAllFiles();
      }else{
        this.queryParams.previewFileItems.push(response);
      }

    },
    // 메소드명 : previewProgress(file, totalBytes, totalBytesSent)
    // ### 드랍존 파일업로드 프로세스 ###
    // dropzoneProgress과 같은 기능.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - file(현재 파일)
    //  - totalBytes(총 데이터 용량)
    //  - totalBytesSent(총 보낸 데이터 용량)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    previewProgress(file, totalBytes, totalBytesSent){
      var dropOrg = this.$refs.dropPreviewFile;
      setTimeout(function(){
          dropOrg.removeAllFiles();
      }, 2500);
    },
    // 메소드명 : handleChange()
    // ### 파일 10개 제한 ###
    // 드래그 드랍 이동시 해당 파일의 순서를 재정렬 한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    handleChange(e) {
      var eventFiles = [];
      console.log(e.target.classList[1]);
      if(e.target.classList[1] == "attachment"){
        eventFiles = this.queryParams.attachmentFileItems;
      }else if(e.target.classList[1] == "preview"){
        eventFiles = this.queryParams.previewFileItems;
      }
      var childNode = e.target.childNodes;
      var childNodeLen = e.target.childNodes.length;

      for (var i = 0; i < eventFiles.length; i ++){
        for (var j = 0; j < childNodeLen; j ++){
          var dataFileUrl = childNode[j].children[1].lastChild.innerText;
          if(eventFiles[i].file_url == dataFileUrl){
            eventFiles[i].file_sequence = (j+1);
          }
        }
      }

      if(e.target.classList[1] == "attachment"){
        this.queryParams.attachmentFileItems = eventFiles;
      }else if(e.target.classList[1] == "preview"){
        this.queryParams.previewFileItems = eventFiles;
      }
    },
    inputChanged(value) {
      console.log(value);
      this.activeNames = value;
    },
    // 메소드명 : getComponentData()
    // ### 드랍앤드래그 리스트 이동 ###
    // 드랍앤드래그 이동시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 : 없음
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    },
    // 메소드명 : salesPayReportInsert()
    // ### 유료 보고서 저장후 옵션 탭으로 이동 ###
    // 유료 보고서는 기본 데이터가 저장된 후에 옵션을 저장할수 있기에 만든 함수.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    salesPayReportInsert() {
      var self = this;
      if(self.formtype == 'insert'){
        self.$validator.validateAll().then(success => {
            if (success) {
              swal.fire({
                title: '유료보고서 옵션 설정!',
                html: "옵션설정시 먼저 기본 보고서 데이터가 저장되야 합니다.</br>저장하시겠습니까?",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK'
              }).then((swalResult) => {
                if (swalResult.value) {
                  var token = sessionStorage.getItem("myToken");
                  var categoryParams = [];

                  self.queryParams.reg_id = self.$session.get('userId');
                  self.queryParams.p_parent_code = "PRDT_TYPE_1";
                  self.queryParams.p_unique_code = self.p_unique_code;

                  self.categoryItems.forEach(function (el, idx, arr){
                    var categoryData = {
                      cate_code: el.item_code
                    }
                    if(el.state){
                      categoryParams.push(categoryData);
                    }
                  });
                  self.queryParams.categoryitems = categoryParams;

                  var param = encodeURI(JSON.stringify(self.queryParams));
                  var data = new FormData();
                  data.append('productObj', param);

                  self.$http.post('/api/insert/drProduct?access_token='+token, data, null)
                    .then((result) => {
                      console.log(result);
                      var resultPCode = result.data;
                      swal.fire({
                        type: 'success',
                        title: '상품을 저장하였습니다.',
                        showConfirmButton: false,
                        timer: 1500
                      }).then(function() {
                          self.optiontap = 'optiontap';
                          self.$router.push('/product/synthesisreport/form?status=update');
                          self.formtype = 'update';
                          self.$session.set('p_param_code', resultPCode);
                          self.p_param_code = self.$session.get('p_param_code');
                          self.getDrProductData(resultPCode);
                      });
                  })
                }else{
                }
              })
            }
        })
      }else{
        this.optiontap = 'optiontap';
      }
    },
    // 메소드명 : handleFileUpload()
    // ### 단일 파일업로드 ###
    // 한개의 파일 업로드를 진행한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - fileType : 파일 타입
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    handleFileUpload(fileType){
      this.queryParams.listThumbnailFile = [];
      var token = sessionStorage.getItem("myToken");
      this.file = this.$refs.file.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('reportType', 'ar');
      formData.append('fileSubPath', 'img');

      this.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((result) => {
          result.data.file_type_code = fileType;
          this.queryParams.listThumbnailFile.push(result.data);
      })
    },
    // 메소드명 : insertDrProduct()
    // ### 보고서 최초 저장 ###
    // 보고서 최초 저장
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    insertDrProduct() {
      var self = this;
      self.$validator.validateAll().then(success => {
          if (success) {
            var token = sessionStorage.getItem("myToken");
            var categoryParams = [];
            self.queryParams.reg_id = self.$session.get('userId');
            self.queryParams.p_parent_code = "PRDT_TYPE_1";
            self.queryParams.p_unique_code = self.p_unique_code;
            self.queryParams.reg_date = moment().format('YYYY-MM-DD HH:mm:ss');
            // self.queryParams.bestview_yn = self.queryParams.bestview_yn ? "Y" : "N";
            self.categoryItems.forEach(function (el, idx, arr){
              var categoryData = {
                cate_code: el.item_code
              }
              if(el.state){
                categoryParams.push(categoryData);
              }
            });
            self.queryParams.categoryitems = categoryParams;

            var param = encodeURI(JSON.stringify(self.queryParams));
            var data = new FormData();
            data.append('productObj', param);

            self.$http.post('/api/insert/drProduct?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '상품이 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                    window.location = "#/product/synthesisreport";
                });
            })
          }
      })
    },
    // 메소드명 : updateDrProduct()
    // ### 보고서 수정 ###
    // 보고서를 각 데이터를 수정한다.
    //
    // 최초작성 : 2016.06.27
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    updateDrProduct() {
      this.$validator.validateAll().then(success => {
          if (success) {
            var token = sessionStorage.getItem("myToken");
            var categoryParams = [];
            console.log(this.queryParams);
            this.queryParams.p_code = this.p_param_code;
            this.queryParams.reg_id = this.$session.get('userId');
            this.queryParams.reg_date = moment().format('YYYY-MM-DD HH:mm:ss');
            // this.queryParams.bestview_yn = this.queryParams.bestview_yn ? "Y" : "N";

            this.categoryItems.forEach(function (el, idx, arr){
              var categoryData = {
                cate_code: el.item_code
              }
              if(el.state){
                categoryParams.push(categoryData);
              }
            });
            this.queryParams.categoryitems = categoryParams;

            var param = encodeURI(JSON.stringify(this.queryParams));
            var data = new FormData();
            data.append('productObj', param);

            this.$http.post('/api/update/drProduct?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '상품을 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    window.location = "#/product/synthesisreport";
                });
            })
          }
      })
    },

    /////////////////////start/////////////////////
    ////////// 파일본 옵션, 패키지 업로드  //////////
    /////////////////////start/////////////////////

    // 메소드명 : addDrSynthesisOpt()
    // ### 종합보고서 파일본 옵션을 최초 저장 ###
    // 옵션을 최초 데이터를 DB에 저장한다.
    //
    // 최초작성 : 2020.04.07
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2020.04.07  황경현   최초작성
    // *************************
    addDrSynthesisOpt(inDatas) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      var parmDatas = inDatas;

      if(parmDatas.name == undefined || parmDatas.name == ""){
        self.valueCheck = true;
      }else{
        self.valueCheck = false;
      }

      if(!self.valueCheck){
        parmDatas.reg_id = self.$session.get('userId');
        parmDatas.p_code = self.p_param_code;
        parmDatas.type = self.tap_option_type;

        if(parmDatas.security_price != 0){
            parmDatas.security_price = $.trim(parmDatas.security_price.replace(/,/g, ''));
        }
        if(parmDatas.normal_price != 0){
            parmDatas.normal_price = $.trim(parmDatas.normal_price.replace(/,/g, ''));
        }
        if(parmDatas.type == "POT_1"){
          if(parmDatas.original_price != 0){
              parmDatas.original_price = $.trim(parmDatas.original_price.replace(/,/g, ''));
          }
        }

        var param = encodeURI(JSON.stringify(parmDatas));

        var data = new FormData();
        data.append('optObj', param);

        if(self.isNew){
          self.$http.post('/api/insert/drSynthesisOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '옵션을 저장하였습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.optDatas = {
                  security_price: 0,
                  normal_price: 0,
                  original_price: 0
                };
                self.pkgDatas = {
                  security_price: 0,
                  normal_price: 0,
                };

                self.securityFileItem = [];
                $("#securityfile").val("");
                self.normalFileItem = [];
                $("#normalfile").val("");
                self.originalFileItem = [];
                $("#originalfile").val("");

                $("#optfile").val("");
                self.isNew = true;
                self.getDrOptList(self.p_param_code);
              });
          })
        }else{
          self.$http.post('/api/update/drSynthesisOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '옵션이 수정되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.optDatas = {security_price: 0, normal_price: 0, original_price: 0};
                self.pkgDatas = {security_price: 0, normal_price: 0};

                self.securityFileItem = [];
                $("#securityfile").val("");
                self.normalFileItem = [];
                $("#normalfile").val("");
                self.originalFileItem = [];
                $("#originalfile").val("");

                self.isNew = true;
                self.getDrOptList(self.p_param_code);
              });
          })
        }
      }
    },
    // 메소드명 : addDrOpt()
    // ### 옵션을 최초 저장 ###
    // 옵션을 최초 데이터를 DB에 저장한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    addDrSynthesisPkgOpt() {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.reportPkgOptDatas.pkgOptList = [];
      self.reportOptions.pkgItems.forEach(function (el, idx, arr){
        var pkgOptData = {
          pkg_code: self.reportOptions.pkg_code,
          opt_code: el.opt_code
        }
        self.reportPkgOptDatas.pkgOptList.push(pkgOptData);
      });

      self.reportPkgOptDatas.p_code = self.p_param_code;
      self.reportPkgOptDatas.p_pkg_code = self.reportOptions.pkg_code;
      var param = encodeURI(JSON.stringify(self.reportPkgOptDatas));
      var data = new FormData();
      data.append('synthesisObj', param);

      self.$http.post('/api/insert/drSynthesisPkgOpt?access_token='+token, data, null)
        .then((result) => {
          self.reportPkgOptDatas.pkgOptList = [];
          self.reportOptions.optItems = [];
          self.reportOptions.pkgItems = [];
          self.formModal = false;
          self.getDrOptList(self.reportcode);

          // swal.fire({
          //   type: 'success',
          //   title: '패키지옵션을 저장하였습니다.',
          //   showConfirmButton: false,
          //   timer: 1000
          // }).then(function() {
            // self.optDatas = {};
            // self.pkgDatas = {};
            // self.optionFileItem = [];
            // $("#optfile").val("");
            // self.isNew = true;
            // self.getDrOptList(self.$route.params.reportcode);
          // });
      })
    },
    // 메소드명 : editOpt(row)
    // ### 옵션을 수정 ###
    // 옵션을 각데이터 마다 수정한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - row : 각row의 데이터
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    editSynthesisOpt(row){
      var self = this;
      $("#securityfile").val("");
      $("#normalfile").val("");
      $("#originalfile").val("");
      self.isNew = false;
      self.optExposureOptions = [
        {text: '비노출',value: 0}
      ];
      self.optList.forEach(function (el, idx, arr){
        var options = {
          text: (idx+1),
          value: (idx+1)
        }
        self.optExposureOptions.push(options);
      });
      row.old_exposure = row.exposure;
      self.optDatas = row;

      self.securityFileItem = [{
        file_originalname: row.security_originalfile_name,
        filesizeStr: row.security_filesizeStr
      }];
      self.normalFileItem = [{
        file_originalname: row.normal_originalfile_name,
        filesizeStr: row.normal_filesizeStr
      }];
      self.originalFileItem = [{
        file_originalname: row.original_originalfile_name,
        filesizeStr: row.original_filesizeStr
      }];
    },
    deleteSynthesisOpt(optdata){
      var self = this;

      swal.fire({
        title: '보고서 옵션 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>보고서의 옵션 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?</b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");
          self.reportOptions.p_code = self.p_param_code;
          self.reportOptions.opt_code = optdata.opt_code;
          var param = encodeURI(JSON.stringify(self.reportOptions));

          var data = new FormData();
          data.append('productOptObj', param);

          self.$http.post('/api/delete/drProductSynthesisOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '옵션이 정상적으로 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.optDatas = {
                  security_price: 0,
                  normal_price: 0,
                  original_price: 0,
                };
                self.pkgDatas = {
                  security_price: 0,
                  normal_price: 0,
                };

                self.securityFileItem = [];
                $("#securityfile").val("");
                self.normalFileItem = [];
                $("#normalfile").val("");
                self.originalFileItem = [];
                $("#originalfile").val("");

                self.isNew = true;
                self.getDrOptList(self.p_param_code);
              });
          })
        }else{
          // cansel
        }
      })
    },
    // 메소드명 : editPkg(row)
    // ### 패키지 수정 ###
    // 패키지를 각데이터 마다 수정한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - row : 각row의 데이터
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    editSynthesisPkg(row){
      var self = this;
      self.isNew = false;
      self.pkgExposureOptions = [
        {text: '비노출',value: 0}
      ];
      self.pkgList.forEach(function (el, idx, arr){
        var pkoptions = {
          text: (idx+1),
          value: (idx+1)
        }
        self.pkgExposureOptions.push(pkoptions);
      });
      row.old_exposure = row.exposure;
      self.pkgDatas = row;
    },
    //////////////////////end//////////////////////
    ////////// 파일본 옵션, 패키지 업로드  //////////
    //////////////////////end//////////////////////

    // 메소드명 : optionFileUpload()
    // ### 옵션에 있는 파일업로드 ###
    // 옵션의 파일을 서버에 업로드 한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    optionFileUpload(){
      this.optionFileItem = [];
      var token = sessionStorage.getItem("myToken");
      this.file = this.$refs.optfile.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('reportType', 'opt');
      formData.append('fileSubPath', 'pdf_ms4');

      this.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((result) => {
        var self = this;
        setTimeout(function(){
          self.optionFileItem.push(result.data);
          self.optDatas.file_name = self.optionFileItem[0].file_originalname;
          self.optDatas.file_path = self.optionFileItem[0].file_path;
          self.optDatas.file_url = self.optionFileItem[0].file_url;
          self.optDatas.file_size = self.optionFileItem[0].file_size;
          self.optDatas.filesizeStr = self.optionFileItem[0].filesizeStr;
        }, 100);
      })
    },
    // 메소드명 : addDrOpt()
    // ### 옵션을 최초 저장 ###
    // 옵션을 최초 데이터를 DB에 저장한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    addDrOpt(inDatas) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      var parmDatas = inDatas;

      if(self.queryParams.p_type == 'PRDT_TYPE_1_1'){
        if(self.isNew){
          if(self.pkgList.length != 0){
            swal.fire({
              type: 'warning',
              title: '옵션 등록!',
              html: '<span style="font-weight:bold">제책본은 옵션 1개만 등록하실수 있습니다.</span>',
              showConfirmButton: true
            }).then(function() {
              self.newPkgClear();
            });
            return false;
          }
        }
      }

      if(parmDatas.name == undefined || parmDatas.name == ''){
        self.valueCheck = true;
      }else{
        self.valueCheck = false;
      }

      console.log(self.p_param_code);
      if(!self.valueCheck){
        parmDatas.reg_id = self.$session.get('userId');
        parmDatas.p_code = self.p_param_code;
        if(parmDatas.security_price != 0){
            parmDatas.security_price = $.trim(parmDatas.security_price.replace(/,/g, ''));
        }
        if(parmDatas.normal_price != 0){
            parmDatas.normal_price = $.trim(parmDatas.normal_price.replace(/,/g, ''));
        }
        var param = encodeURI(JSON.stringify(parmDatas));

        var data = new FormData();
        data.append('optObj', param);

        console.log(parmDatas);
        if(self.isNew){
          self.$http.post('/api/insert/drProductOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '패키지옵션을 저장하였습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.pkgDatas = {security_price: 0, normal_price: 0};
                self.isNew = true;
                self.getDrOptList(self.p_param_code);
              });
          })
        }else{
          self.$http.post('/api/update/drProductOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '패키지옵션이 수정되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.pkgDatas = {security_price: 0, normal_price: 0};
                self.isNew = true;
                self.getDrOptList(self.p_param_code);
              });
          })
        }
      }
    },
    // 메소드명 : addDrOpt()
    // ### 옵션을 최초 저장 ###
    // 옵션을 최초 데이터를 DB에 저장한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    addDrPkgOpt() {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.reportPkgOptDatas.pkgOptList = [];
      self.reportOptions.pkgItems.forEach(function (el, idx, arr){
        var pkgOptData = {
          pkg_code: self.reportOptions.pkg_code,
          opt_code: el.opt_code
        }
        self.reportPkgOptDatas.pkgOptList.push(pkgOptData);
      });
      console.log(self.reportOptions);
      self.reportPkgOptDatas.p_code = self.p_param_code;
      self.reportPkgOptDatas.p_pkg_code = self.reportOptions.pkg_code;
      var param = encodeURI(JSON.stringify(self.reportPkgOptDatas));
      var data = new FormData();
      data.append('productObj', param);

      self.$http.post('/api/insert/drProductPkgOpt?access_token='+token, data, null)
        .then((result) => {
          self.reportPkgOptDatas.pkgOptList = [];
          self.reportOptions.optItems = [];
          self.reportOptions.pkgItems = [];
          self.formModal = false;
          self.getDrOptList(self.p_param_code);

          // swal.fire({
          //   type: 'success',
          //   title: '패키지옵션을 저장하였습니다.',
          //   showConfirmButton: false,
          //   timer: 1000
          // }).then(function() {
            // self.optDatas = {};
            // self.pkgDatas = {};
            // self.optionFileItem = [];
            // $("#optfile").val("");
            // self.isNew = true;
            // self.getDrOptList(self.$route.params.reportcode);
          // });
      })
    },
    // 메소드명 : editOpt(row)
    // ### 옵션을 수정 ###
    // 옵션을 각데이터 마다 수정한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - row : 각row의 데이터
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    editOpt(row){
      $("#optfile").val("");
      this.isNew = false;
      this.optDatas = row;
      this.optionFileItem = [{
        file_originalname: row.file_name,
        filesizeStr: row.filesizeStr
      }];
    },
    // 메소드명 : editPkg(row)
    // ### 패키지 수정 ###
    // 패키지를 각데이터 마다 수정한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - row : 각row의 데이터
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    editPkg(row){
      var self = this;
      self.isNew = false;
      self.pkgExposureOptions = [];
      self.pkgList.forEach(function (el, idx, arr){
        var pkoptions = {
          text: (idx+1),
          value: (idx+1)
        }
        self.pkgExposureOptions.push(pkoptions);
      });
      row.old_exposure = row.exposure;
      self.pkgDatas = row;
    },
    newPkgClear(){
      this.isNew = true;
      this.pkgDatas = {
        exposure: (this.pkgExposureOptions.length-1),
        price: 0
      };
      this.getDrOptList(this.p_param_code);
  	},
    openOptPkg(row){
      console.log(row);
      var self = this;
      self.reportOptions.optItems = self.$_.clone(self.optList);
      self.reportOptions.pkgItems = [];
      self.reportOptions.pkg_code = row.opt_code;
      self.formModal = true;
      self.getDrPkgOptList(self.reportOptions.pkg_code);
    },
    // addOptPkg(){
    //   this.formModal = true;
    // },
    getDrOptList (p_param_code) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.optExposureOptions = [
        {text: '비노출',value: 0}
      ],
      self.pkgExposureOptions = [
        {text: '비노출',value: 0}
      ],
      self.$http.get('/api/select/drProductOptList?access_token=' + token + '&p_param_code=' + p_param_code + '&p_sub_type=' + self.queryParams.p_sub_type)
      .then((result) => {
        console.log(result.data);
        if(self.queryParams.p_sub_type == 'PRDT_TYPE_1_1_1'){
          self.optList = result.data.optList;
          self.pkgList = result.data.pkgList;
          self.synthesis_option_type = 'SOT_TYPE_1';
        }else if(self.queryParams.p_sub_type == 'PRDT_TYPE_1_1_2'){
          self.pkgList = result.data.synthesisPkgList;
          self.optList = result.data.synthesisOptList;
          self.synthesis_option_type = 'SOT_TYPE_2';
        }else if(self.queryParams.p_sub_type == 'PRDT_TYPE_1_1_3'){
          self.optList = result.data.synthesisOptList;
          self.pkgList = result.data.pkgList;
        }

        if(self.queryParams.p_sub_type == 'PRDT_TYPE_1_1_2' || self.queryParams.p_sub_type == 'PRDT_TYPE_1_1_3'){
          if(self.optList.length > 0){
            self.optList.forEach(function (el, idx, arr){
              var options = {
                text: (idx+1),
                value: (idx+1)
              }
              el.security_price = Number(el.security_price).toLocaleString();
              el.normal_price = Number(el.normal_price).toLocaleString();
              el.original_price = Number(el.original_price).toLocaleString();
              self.optExposureOptions.push(options);
            });
          }
          self.optExposureOptions.push({text: (self.optList.length+1),value: (self.optList.length+1)});
          self.optDatas.exposure = (self.optExposureOptions.length-1);
        }

        if(self.pkgList.length > 0){
          self.pkgList.forEach(function (el, idx, arr){
            var pkoptions = {
              text: (idx+1),
              value: (idx+1)
            }
            if(el.security_price != 0){
              el.security_price = Number(el.security_price).toLocaleString();
            }
            if(el.normal_price != 0){
              el.normal_price = Number(el.normal_price).toLocaleString();
            }
            self.pkgExposureOptions.push(pkoptions);
          });
        }
        self.pkgExposureOptions.push({text: (self.pkgList.length+1),value: (self.pkgList.length+1)});
        self.pkgDatas.exposure = (self.pkgExposureOptions.length-1);
      })
    },
    getDrPkgOptList (pkgcode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.reportOptions.p_code = self.p_param_code;
      self.reportOptions.pkg_code = pkgcode;
      var param = encodeURI(JSON.stringify(self.reportOptions));

      var data = new FormData();
      data.append('productPkgObj', param);

      console.log(self.reportOptions);
      self.$http.post('/api/select/drSynthesisPkgOptList?access_token=' + token, data, null)
      .then((result) => {
        self.reportPkgOptDatas = result.data;
        self.reportPkgOptDatas.pkgOptList.forEach(function (t_el, t_idx, t_arr){
          self.reportOptions.optItems.forEach(function (s_el, s_idx, s_arr){
            if(t_el.opt_code == s_el.opt_code){
              self.reportOptions.pkgItems.push(s_el);
              self.reportOptions.optItems.splice(s_idx, 1);
            }
          });
        });
      })
    },
    // 메소드명 : securityFileUpload()
    // ### 옵션에 있는 보안 파일업로드 ###
    // 옵션의 파일을 서버에 업로드 한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.07.10  황경현   최초작성
    // *************************
    securityFileUpload(){
      var self = this;
      self.securityFileItem = [];
      self.optDatas.security_originalfile_name = "";
      self.optDatas.security_filesizeStr = "";
      var token = sessionStorage.getItem("myToken");
      self.file = self.$refs.securityfile.files[0];
      let formData = new FormData();
      formData.append('file', self.file);
      formData.append('reportType', 'opt');
      formData.append('fileSubPath', 'ms4');

      self.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((result) => {
        setTimeout(function(){
          self.securityFileItem.push(result.data);
          self.optDatas.security_originalfile_name = self.securityFileItem[0].file_originalname;
          self.optDatas.security_file_name = self.securityFileItem[0].file_name;
          self.optDatas.security_file_path = self.securityFileItem[0].file_path;
          self.optDatas.security_file_url = self.securityFileItem[0].file_url;
          self.optDatas.security_file_size = self.securityFileItem[0].file_size;
          self.optDatas.security_filesizeStr = self.securityFileItem[0].filesizeStr;
        }, 100);
      })
    },
    // 메소드명 : normalFileUpload()
    // ### 옵션에 있는 일반 파일업로드 ###
    // 옵션의 파일을 서버에 업로드 한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    normalFileUpload(){
      var self = this;
      self.normalFileItem = [];
      self.optDatas.normal_originalfile_name = "";
      self.optDatas.normal_filesizeStr = "";
      var token = sessionStorage.getItem("myToken");
      self.file = self.$refs.normalfile.files[0];
      let formData = new FormData();
      formData.append('file', self.file);
      formData.append('reportType', 'opt');
      formData.append('fileSubPath', 'pdf');
      $("#normalProgress").show();
      self.progressCounter = 0;
      self.progressTimer = setInterval(() => {
        if(self.progressCounter == 100){
          self.progressCounter = 100;
        }else{
          self.progressCounter += 10;
        }
      }, 1000)
      self.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((result) => {
        setTimeout(function(){
          self.normalFileItem.push(result.data);
          self.optDatas.normal_originalfile_name = self.normalFileItem[0].file_originalname;
          self.optDatas.normal_file_name = self.normalFileItem[0].file_name;
          self.optDatas.normal_file_path = self.normalFileItem[0].file_path;
          self.optDatas.normal_file_url = self.normalFileItem[0].file_url;
          self.optDatas.normal_file_size = self.normalFileItem[0].file_size;
          self.optDatas.normal_filesizeStr = self.normalFileItem[0].filesizeStr;
        }, 100);
        setTimeout(function(){
          clearInterval(self.progressTimer);
          self.progressTimer = null;
          self.progressCounter = 100;
          $("#normalProgress").hide();
        }, 500);
      })
    },
    // 메소드명 : originalFileUpload()
    // ### 옵션에 있는 원본 파일업로드 ###
    // 옵션의 파일을 서버에 업로드 한다.
    //
    // 최초작성 : 2016.07.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.07.10  황경현   최초작성
    // *************************
    originalFileUpload(){
      this.originalFileItem = [];
      self.optDatas.original_originalfile_name = "";
      self.optDatas.original_filesizeStr = "";
      var token = sessionStorage.getItem("myToken");
      this.file = this.$refs.originalfile.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('reportType', 'opt');
      formData.append('fileSubPath', 'original');

      this.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((result) => {
        var self = this;
        setTimeout(function(){
          self.originalFileItem.push(result.data);
          self.optDatas.original_originalfile_name = self.originalFileItem[0].file_originalname;
          self.optDatas.original_file_name = self.originalFileItem[0].file_name;
          self.optDatas.original_file_path = self.originalFileItem[0].file_path;
          self.optDatas.original_file_url = self.originalFileItem[0].file_url;
          self.optDatas.original_file_size = self.originalFileItem[0].file_size;
          self.optDatas.original_filesizeStr = self.originalFileItem[0].filesizeStr;
        }, 100);
      })
    },
    securityFileYnCheck() {
      var self = this;
      if(!self.securityFileYn){
        if(self.securityFileItem.length > 0){
          swal.fire({
            title: '옵션 보안 파일!',
            // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
            html: "저장된 보안 파일이 있습니다.</br>삭제 하시겠습니까?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              $("#securityfile").val("");
              self.securityFileItem = [];
              self.optDatas.security_originalfile_name = "";
              self.optDatas.security_file_name = "";
              self.optDatas.security_file_path = "";
              self.optDatas.security_file_url = "";
              self.optDatas.security_file_size = 0;
              self.optDatas.security_filesizeStr = "";
            }else{
              self.securityFileYn = false;
            }
          })
        }else{
          $("#securityfile").val("");
          self.securityFileItem = [];
          self.optDatas.security_originalfile_name = "";
          self.optDatas.security_file_name = "";
          self.optDatas.security_file_path = "";
          self.optDatas.security_file_url = "";
          self.optDatas.security_file_size = 0;
          self.optDatas.security_filesizeStr = "";
        }
      }
    },
    normalFileYnCheck() {
      var self = this;
      if(!self.normalFileYn){
        if(self.normalFileItem.length > 0){
          swal.fire({
            title: '옵션 일반 파일!',
            // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
            html: "저장된 일반 파일이 있습니다.</br>삭제 하시겠습니까?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              $("#normalfile").val("");
              self.normalFileItem = [];
              self.optDatas.normal_originalfile_name = "";
              self.optDatas.normal_file_name = "";
              self.optDatas.normal_file_path = "";
              self.optDatas.normal_file_url = "";
              self.optDatas.normal_file_size = 0;
              self.optDatas.normal_filesizeStr = "";
            }else{
              self.normalFileYn = false;
            }
          })
        }else{
          $("#optfile").val("");
          self.normalFileItem = [];
          self.optDatas.normal_originalfile_name = "";
          self.optDatas.normal_file_name = "";
          self.optDatas.normal_file_path = "";
          self.optDatas.normal_file_url = "";
          self.optDatas.normal_file_size = 0;
          self.optDatas.normal_filesizeStr = "";
        }
      }
    },
    originalFileYnCheck() {
      var self = this;
      if(!self.originalFileYn){
        if(self.originalFileItem.length > 0){
          swal.fire({
            title: '옵션 원본 파일!',
            // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
            html: "저장된 원본 파일이 있습니다.</br>삭제 하시겠습니까?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              $("#originalfile").val("");
              self.originalFileItem = [];
              self.optDatas.original_originalfile_name = "";
              self.optDatas.original_file_name = "";
              self.optDatas.original_file_path = "";
              self.optDatas.original_file_url = "";
              self.optDatas.original_file_size = 0;
              self.optDatas.original_filesizeStr = "";
            }else{
              self.originalFileYn = false;
            }
          })
        }else{
          $("#originalfile").val("");
          self.originalFileItem = [];
          self.optDatas.original_originalfile_name = "";
          self.optDatas.original_file_name = "";
          self.optDatas.original_file_path = "";
          self.optDatas.original_file_url = "";
          self.optDatas.original_file_size = 0;
          self.optDatas.original_filesizeStr = "";
        }
      }
    },
    optFileYnCheck() {
      var self = this;
      if(!self.optFileYn){
        if(self.optionFileItem.length > 0){
          swal.fire({
            title: '옵션 파일!',
            // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
            html: "저장된 파일이 있습니다.</br>삭제 하시겠습니까?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              $("#optfile").val("");
              self.optionFileItem = [];
              self.optDatas.file_name = "";
              self.optDatas.file_path = "";
              self.optDatas.file_url = "";
              self.optDatas.filesizeStr = "";
            }else{
              self.optFileYn = false;
            }
          })
        }else{
          $("#optfile").val("");
          self.optionFileItem = [];
          self.optDatas.file_name = "";
          self.optDatas.file_path = "";
          self.optDatas.file_url = "";
          self.optDatas.filesizeStr = "";
        }
      }
    },
    synthesisOptTapCheck(event,check){
      if(!check){
        this.booktapCheck = !this.booktapCheck;
        this.opttapCheck = !this.opttapCheck;
      }else{
        event.target.checked = true;
      }
    },
    optPkgCheck(event,check){
      if(!check){
        this.opttapCheck = !this.opttapCheck;
        this.pkgtapCheck = !this.pkgtapCheck;
      }else{
        event.target.checked = true;
      }
    },
    /**
    * 이미지 파일 업로드
    */
    uploadSummernoteImageFile(file, editor) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var data = new FormData();
      data.append("file", file);

      self.$http.post('/ftpserver/editorImageUpload?access_token='+token, data, null)
      .then((result) => {
        $(editor).summernote('insertImage', result.data);
      })
    }
  }
}

$(document).ready(function(){
	var xOffset = 50;
  var yOffset = 10;
  $(document).on("mouseover",".imgview",function(e){ //마우스 오버시
      $("body").append("<p id='preview'><img src='"+ $(this).attr("data") +"' /></p>"); //보여줄 이미지를 선언
      $("#preview")
          .css("position","absolute")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px")
          .fadeIn("fast"); //미리보기 화면 설정 셋팅
  });
  $(document).on("mousemove",".imgview",function(e){ //마우스 이동시
      $("#preview")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px");
  });
  $(document).on("mouseout",".imgview",function(){ //마우스 아웃시
      $("#preview").remove();
  });
});
</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css">



// WEBPACK FOOTER //
// src/views/product/SynthesisReportForm.vue